import React, { useState, useEffect } from "react";
import { Toast } from "../../Components";
import MyProfileInfo from "./MyProfileInfo";
import { format } from "date-fns";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { getCache, setCache } from "../../Helpers/cachedata";
import {
  influencerService,
  alertService,
  commonapiService,
} from "../../Services";
import moment from "moment";

const genderList = [
  { id: "m", value: "Male", apiCode: "m" },
  { id: "f", value: "Female", apiCode: "f" },
  { id: "o", value: "Other", apiCode: "o" },
  { id: "x", value: "Prefer not to say", apiCode: "x" },
];

export default function MyProfile(props) {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    data: {
      firstName: "",
      lastName: "",
      email: "",
      phonenumber: "",
      country_id: "",
      gender: "",
    },
    dateofbirth: "",
    profile_img: "",
    uploaded_profile_photo: "",
    bio: "",
  });
  const [toastList, setToastList] = useState([]);
  const [error, setError] = useState(false);
  const [isCountryLoaded, setIsCountryLoaded] = useState(false);
  const [country, setCountry] = useState(null);
  const [configData, setConfigData] = useState(null);
  const [isConfigDataLoaded, setIsConfigDataLoaded] = useState(false);

  const updateForm = (data) => {
    setForm({ ...form, ...data });
  };

  useEffect(() => {
    props.setShowConfirmInfModal(false);

    async function fetchInfluencerData() {
      try {
        const res = await influencerService.getInfluencerDetails();
        console.log("🚀 ~ fetchInfluencerData ~ res:", res?.data?.dateofbirth);
        const dateOfBirth =
          res?.data?.dateofbirth && !isNaN(new Date(res?.data?.dateofbirth))
            ? new Date(res?.data?.dateofbirth)
            : "";

        setForm({
          data: {
            firstName: res?.data?.firstName || "",
            lastName: res?.data?.lastName || "",
            email: res?.data?.email || "",
            phonenumber: res?.data?.phonenumber || "",
            country_id: res?.data?.country_id || "",
            gender: res?.data?.gender || "",
          },
          dateofbirth: dateOfBirth,
        });
      } catch (err) {
        alertService.error(err);
      }
    }

    async function fetchCountry() {
      try {
        const cachedDataforCountry = getCache("country");
        if (cachedDataforCountry) {
          setCountry(cachedDataforCountry);
          setIsCountryLoaded(true);
        } else {
          const res = await commonapiService.getCountry();
          if (res.data != null && res.success == true) {
            setCountry(res.data);
            setCache("country", res.data);
          }
          setIsCountryLoaded(true);
        }
      } catch (err) {
        if (err.apiResponseStatus != 404) {
          addToast({
            error: true,
            msg: err.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        } else {
          setIsCountryLoaded(true);
        }
      }
    }

    async function fetchOtherConfigData() {
      try {
        const res = await commonapiService.getConfigData();
        if (res) {
          setConfigData(res);
        }
        setIsConfigDataLoaded(true);
      } catch (err) {
        addToast({
          error: true,
          msg: err,
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }

    fetchInfluencerData();
    fetchCountry();
    fetchOtherConfigData();
  }, []);

  const setInput = (key) => (event) => {
    props.setShowConfirmInfModal(true);
    updateForm({
      data: {
        ...form.data,
        [key]: event.target.value,
      },
    });
  };

  const addToast = (data) => {
    const newToastList = [...toastList];
    if (data.msg) {
      if (data.msg[data.msg.length - 1] === ".")
        data.msg = data.msg.slice(0, -1);
    }
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  useEffect(() => {
    if (props.saveProfile === true) {
      saveChanges();
    }
  }, [props.saveProfile]);

  const getGenderApiCode = (genderId) => {
    const genderItem = genderList.find((item) => item.id === genderId);
    return genderItem ? genderItem.apiCode : "";
  };

  const saveChanges = async () => {
    setError(false);

    let hasError = false;

    if (
      form.data.firstName === "" ||
      form.data.email === "" ||
      form.data.gender === "" ||
      form.data.country_id === "" ||
      form.data.country_id === 0
    ) {
      hasError = true;
    }

    if (hasError) {
      setError(true);
      if (props.saveProfile == true) {
        props.setSaveProfile(false);
      }
      props.setSaveProfileFormValid(false);
      return;
    } else {
      props.setSaveProfileFormValid(true);

      const jsonData = {
        firstName: form.data.firstName,
        lastName: form.data.lastName,
        email: form.data.email,
        phonenumber: form.data.phonenumber,
        dateofbirth:
          form.dateofbirth &&
          moment(form.dateofbirth, moment.ISO_8601, true).isValid()
            ? moment(form.dateofbirth).format("YYYY/MM/DD")
            : "",
        country_id: form.data.country_id,
        gender: getGenderApiCode(form.data.gender),
      };

      try {
        const res = await influencerService.saveProfileDetails(jsonData, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        props.setShowConfirmInfModal(false);
        addToast({
          error: false,
          date: new Date(),
          msg: "Profile saved successfully",
        });

        if (props.saveProfile == true) {
          props.setSaveProfile(false);
          props.setShowConfirmInfModal(false);
          navigate("/influencer/gallery");
        }
      } catch (err) {
        props.setShowConfirmInfModal(false);
        if (props.saveProfile == true) {
          props.setSaveProfile(false);
        }

        let errorMessage = "Failed to save profile. Please try again.";

        if (err === "No Content") {
          errorMessage = "Please fill in all required fields.";
        } else if (err?.message) {
          errorMessage = err.message;
        } else if (typeof err === "string") {
          errorMessage = err;
        } else if (err?.response?.data?.message) {
          errorMessage = err.response.data.message;
        } else if (!navigator.onLine) {
          errorMessage = "No internet connection. Please check your network.";
        }

        addToast({
          error: true,
          date: new Date(),
          msg: errorMessage,
        });
      }
    }
  };

  return (
    <>
      <div className="min-h-screen mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="bg-white  rounded-2xl sm:rounded-3xl shadow-lg sm:shadow-xl shadow-green-200/50 overflow-hidden"
        >
          <div className="border-b border-green-100 bg-gradient-to-r from-green-50 to-emerald-50 px-4 sm:px-6 py-4 sm:py-6">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-lg sm:text-xl font-bold text-gray-900 flex items-center gap-2">
                  <div className="w-2 h-6 bg-gradient-to-b from-green-500 to-emerald-500 rounded-full"></div>
                  Personal Information
                </h2>
                <p className="text-green-600 mt-1 text-xs sm:text-sm">
                  Update your basic profile details
                </p>
              </div>
              <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-xl bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center shadow-lg">
                <svg
                  className="w-4 h-4 sm:w-5 sm:h-5 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div className="px-4 sm:px-6 py-6">
            <div className="space-y-6">
              {isCountryLoaded && isConfigDataLoaded && (
                <MyProfileInfo
                  form={form}
                  setInput={setInput}
                  addToast={addToast}
                  error={error}
                  updateForm={updateForm}
                  countries={country}
                  setShowConfirmInfModal={props.setShowConfirmInfModal}
                  genderList={genderList}
                />
              )}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-end pt-6 mt-6 border-t border-green-100 gap-4 sm:gap-0">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={saveChanges}
                className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-2 text-sm sm:text-base"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                Save Changes
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>

      {toastList && <Toast list={toastList} setList={setToastList} />}
    </>
  );
}
